import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=1bed2b58&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=1bed2b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed2b58",
  null
  
)

export default component.exports